import React, { useEffect, useReducer, useState } from "react"
import { obterPeriodos } from "../../../services/periodoEntregaFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { PeriodoEntregaFornecedorInicial } from "../models/periodoEntregaFornecedorModel"
import { PeriodoEntregaFornecedorActionsTypes } from "./periodoEntregaFornecedorActions"
import { PeriodoEntregaFornecedorContext } from "./PeriodoEntregaFornecedorContext"
import { periodoEntregaFornecedorReducer } from "./periodoEntregaFornecedorReducer"

export function PeriodoEntregaFornecedorContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        periodoEntregaFornecedorReducer,
        PeriodoEntregaFornecedorInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterPeriodos(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: PeriodoEntregaFornecedorActionsTypes.CARREGAR,
                    payload: response,
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <PeriodoEntregaFornecedorContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </PeriodoEntregaFornecedorContext.Provider>
    )
}
